import React, { useEffect, useState } from 'react';
import './UsersList.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faGear, faTrashCan, faXmark } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';


const config=require( '../../config.js');

function UsersList() {
    const [users, setUsers] = useState([]);
    const navigate = useNavigate();
    const [filteredUsers, setFilteredUsers] = useState([]);

    const fetchUsers = async () => {
        try {
            const response = await fetch(config.env.API_BASE_URL + '/api/users', {
                headers: {
                    'Authorization': 'Bearer ' + localStorage.getItem('token')
                }
            });
            if (response.ok) {
                const data = await response.json();
                setUsers(data);
                setFilteredUsers(data);
            } else {
                console.error('Failed to fetch users');
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };

    useEffect(() => {
        fetchUsers(); 
    }, []);

    let myFilters = {
        name: "",
        email: "",
        role: "",
    };
    const calculateTable = () => {
    let newUsers = users.filter((user) => {
      if (
        user.name && user.name
          .toString()
          .toLowerCase()
          .includes(myFilters.name.toString().toLowerCase()) &&
        user.email && user.email
          .toString()
          .toLowerCase()
          .includes(myFilters.email.toString().toLowerCase()) &&
        user.role && user.role
          .toString()
          .toLowerCase()
          .includes(myFilters.role.toString().toLowerCase())
      ) {
        return true;
      } else {
        return false;
      }
    });
    setFilteredUsers(newUsers);
  };

    const handleRole = (user) => {
        navigate(`/users/${user._id}/role/${user.role}`);
    };

    const handleEnableUser = async (id) => {
        try {
            const response = await fetch(config.env.API_BASE_URL+`/api/users/${id}/enable`, {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + localStorage.getItem('token')
                }
            });
            if (response.ok) {
                fetchUsers()
                alert('User enabled successfully');
            } else {
                console.error('Failed to enable user');
            }
        } catch (error) {
            console.error('Error enable user:', error);
        }
    };

    const handleDisableUser = async (id) => {
        try {
            const response = await fetch(config.env.API_BASE_URL+`/api/users/${id}/disable`, {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + localStorage.getItem('token')
                }
            });
            if (response.ok) {
                fetchUsers()
                alert('User disabled successfully');
            } else {
                console.error('Failed to disable user');
            }
        } catch (error) {
            console.error('Error disable user:', error);
        }
    };

    const handleDelete = async (id) => {
        try {
            const response = await fetch(config.env.API_BASE_URL+`/api/users/${id}`, {
                method: 'DELETE',
                headers: {
                    'Authorization': 'Bearer ' + localStorage.getItem('token')
                }
            });
            if (response.ok) {
                fetchUsers();
                alert('User deleted successfully');
            } else {
                console.error('Failed to delete user');
            }
        } catch (error) {
            console.error('Error deleting user:', error);
        }
    };

    return (
        <>
            <div className='d-flex container justify-content-end'>
                <button className='btn-Create mt-3' onClick={() => navigate('/users/create')}>
                    Create User
                </button>
            </div>
            <div className='mt-5 Crud-main-container container' style={{ color: "#9C9CA5" }}>
                <div style={{ fontSize: "24px" }}>Filters</div>
                <div
                style={{
                    display: "flex",
                    flexWrap: "wrap",
                    marginTop: "16px",
                    marginBottom: "16px",
                    gap: "24px",
                    paddingLeft: "12px",
                    paddingRight: "12px",
                    placeContent: "center",
                }}
                >
                   <div>
                    <div
                    style={{ fontSize: "16px", color: "#9C9CA5", textAlign: "left" }}
                    >
                    Name
                    </div>
                    
                    <input
                    placeholder='Name'
                    onChange={(event) => {
                        myFilters.name = event.target.value;
                        calculateTable();
                    }}
                    style={{
                        background: "white",
                        width: "200px",
                        color: "#9C9CA5",
                        borderRadius: "16px",
                        paddingTop: "4px",
                        paddingBottom: "4px",
                        paddingLeft: "12px",
                    }}
                    ></input>
                </div> 

                <div>
                    <div
                    style={{ fontSize: "16px", color: "#9C9CA5", textAlign: "left" }}
                    >
                    Email
                    </div>
                    
                    <input
                    placeholder='Email'
                    onChange={(event) => {
                        myFilters.email = event.target.value;
                        calculateTable();
                    }}
                    style={{
                        background: "white",
                        width: "200px",
                        color: "#9C9CA5",
                        borderRadius: "16px",
                        paddingTop: "4px",
                        paddingBottom: "4px",
                        paddingLeft: "12px",
                    }}
                    ></input>
                </div> 

                <div>
                    <div
                    style={{ fontSize: "16px", color: "#9C9CA5", textAlign: "left" }}
                    >
                    Role
                    </div>
                    
                    <input
                    placeholder='Role'
                    onChange={(event) => {
                        myFilters.role = event.target.value;
                        calculateTable();
                    }}
                    style={{
                        background: "white",
                        width: "200px",
                        color: "#9C9CA5",
                        borderRadius: "16px",
                        paddingTop: "4px",
                        paddingBottom: "4px",
                        paddingLeft: "12px",
                    }}
                    ></input>
                </div> 
                </div>
                <table className="table Crud-main container">
                    <thead>
                        <tr className="Crud-thead-wrapper">
                            <th scope="col" className='text-start'>Name</th>
                            <th scope="col">Email</th>
                            <th scope="col">Type</th>
                            <th scope="col">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredUsers
                            .slice()
                            .map((user) => (
                                <tr key={user._id}>
                                    <td className='w-50 text-start'>{user.name}</td>
                                    <td>{user.email}</td>
                                    <td>{user.role}</td>
                                    <td>
                                        {
                                            user.enabled && (
                                            <FontAwesomeIcon
                                                onClick={() => {
                                                    if(window.confirm('Are you sure you want to disable this user?')) {
                                                        handleDisableUser(user._id)
                                                    }
                                                }}
                                                className='icon'
                                                icon={faXmark}
                                            /> )
                                        }
                                        {
                                            !user.enabled && (
                                            <FontAwesomeIcon
                                                onClick={() => {
                                                    if(window.confirm('Are you sure you want to enable this user?')) {
                                                        handleEnableUser(user._id)
                                                    }
                                                }}
                                                className='icon'
                                                icon={faCheck}
                                            /> )
                                        }
                                        <FontAwesomeIcon
                                            onClick={() => handleRole(user)}
                                            className='icon'
                                            icon={faGear}
                                        />
                                        <FontAwesomeIcon
                                            onClick={() => {
                                                if (window.confirm('Are you sure you want to delete this user?')) {
                                                    handleDelete(user._id);
                                                }
                                            }}
                                            className='icon trash'
                                            icon={faTrashCan}
                                        />
                                    </td>
                                </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </>
    );
}

export default UsersList;
